import { render, staticRenderFns } from "./AuthBackground.vue?vue&type=template&id=7b3517b8&scoped=true"
import script from "./AuthBackground.vue?vue&type=script&lang=js"
export * from "./AuthBackground.vue?vue&type=script&lang=js"
import style0 from "./AuthBackground.vue?vue&type=style&index=0&id=7b3517b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3517b8",
  null
  
)

export default component.exports